module.exports = __webpack_public_path__ + "img/de-praktijk-1.1391bf29.jpg";